import React from 'react';
import { calculateAge } from '@shared/helpers/calculateAge';
import EnteredDataSection from '@shared/components/EnteredDataSection';

const PassengersDetails = ({ storagePassengers, passengers, countries }) => {
  const fieldsList = passengers.map((passenger, index) => ({
    [`Pasajero ${index + 1} - Producto: ${storagePassengers.nombreTarifa}`]: '',
    'Nombre y Apellido': `${passenger.name} ${passenger.last_name}`,
    Edad: calculateAge(passenger.birthdate),
    Documento: passenger.document_number,
    País: countries[index]?.description,
  }));

  return <EnteredDataSection title="" fieldsList={fieldsList} />;
};

export default PassengersDetails;
